import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Table from "../../../_common/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EditKeywordModal from "./EditKeywordModal";
import KeywordDetails from "./KeywordDetails";
import { docPermConstants } from "../../../../_constants/permissionConstants";
import keywordActions from "../../../../_actions/keywordActions";

class KeywordsMain extends Component {
  state = {
    isNew: false,
    showEditKeywordModal: false,
    selectedKeywordId: null,
    keywordFilter: "",
    hasLinks: false,
    sortColumn: { path: "keywordTag", order: "asc" },
  };

  columns = [
    {
      path: "keywordTag",
      label: "Keyword Tag",
      content: (kw) => (
        <span className="span-bubble-light p-1 bg-light mr-1">{kw.keywordTag}</span>
      ),
    },
    {
      path: "isDefault",
      label: "Default?",
      content: (kw) => (kw.isDefault ? "Yes" : "No"),
    },
  ];

  componentDidMount() {
    const { dispatch, projectId } = this.props;
    dispatch(keywordActions.getAll(projectId));
  }

  handleChange_keywordFilter = (e) => this.setState({ keywordFilter: e.target.value });
  handleSort = (sortColumn) => this.setState({ sortColumn });
  handleClick_clearFilters = (e) => {
    e.preventDefault();
    this.setState({ keywordFilter: "" });
  };

  handleClick_keywordTr = (selectedKeyword) => {
    const { dispatch, projectId } = this.props;
    this.setState({ selectedKeywordId: selectedKeyword.keywordId }, () =>
      dispatch(keywordActions.getDetails(selectedKeyword.keywordId, projectId))
    );
  };

  handleClick_editKeyword = (e) => {
    e.preventDefault();
    this.setState({ isNew: false }, this.toggleEditKeywordModal);
  };

  deleteCallback = () => this.setState({ selectedKeyword: null });

  // Perform auth check to ensure only RESR can access
  handleClick_addKeyword = (e) => {
    e.preventDefault();
    this.setState({
      isNew: true,
      selectedKeywordId: null,
      showEditKeywordModal: true,
    });
  };

  toggleEditKeywordModal = () =>
    this.setState({
      showEditKeywordModal: !this.state.showEditKeywordModal,
    });

  getData = () => {
    const { projKeywordList } = this.props;
    const { keywordFilter, sortColumn } = this.state;

    const filteredByKw =
      keywordFilter !== null
        ? (projKeywordList || []).filter((c) =>
            c.keywordTag.toLowerCase().includes(keywordFilter.trim().toLowerCase())
          )
        : projKeywordList || [];
    return _.orderBy(filteredByKw, [sortColumn.path], [sortColumn.order]);
  };

  renderTableFilters = (data) => {
    const { keywordFilter } = this.state;
    const { permissions } = this.props;
    return (
      <div className="d-flex flex-row pa-filter-group w-100 mb-1">
        <div className="pa-filter-item pa-filter-item__input flex-grow-1">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <FontAwesomeIcon icon="search" className="fa-fw text-muted" />
              </span>
            </div>
            <input
              name="keywordFilter"
              id="keywordFilter"
              className="form-control mr-2"
              value={keywordFilter}
              onChange={this.handleChange_keywordFilter}
            />
          </div>
        </div>
        <div className="pa-filter-item pa-filter-item__btn">
          <button
            type="button"
            name="addKeyword"
            id="addKeyword"
            className="btn btn-info"
            onClick={this.handleClick_addKeyword}
            disabled={!permissions.includes(docPermConstants.EDIT_LEVEL_2)}
          >
            <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
            Add...
          </button>
        </div>
      </div>
    );
  };

  render() {
    const { projectId, user, permissions } = this.props;
    const { selectedKeywordId, showEditKeywordModal, isNew, sortColumn } = this.state;
    const data = this.getData();
    return (
      <React.Fragment>
        <div className="d-flex flex-row p-2 w-100">
          <div className="pa-list">
            {this.renderTableFilters()}
            <div className="pa-list__table--wrapper border">
              <Table
                className="table table-sm table-hover pa-list__table"
                data={data}
                columns={this.columns}
                idPropName="keywordId"
                selectedItemId={selectedKeywordId && selectedKeywordId}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                handleClick_tr={this.handleClick_keywordTr}
              />
            </div>
          </div>
          <div className="pa-details">
            <div className="card">
              <div className="card-header bg-lightgray">Keyword Details</div>
              <div className="card-body p-3">
                <KeywordDetails
                  permissions={permissions}
                  projectId={projectId}
                  keywordId={selectedKeywordId}
                  handleClick_editKeyword={this.handleClick_editKeyword}
                  deleteCallback={this.deleteCallback}
                />
              </div>
            </div>
          </div>
        </div>
        {showEditKeywordModal && (
          <EditKeywordModal
            projectId={projectId}
            selectedKeyword={data.find((kw) => kw.keywordId === selectedKeywordId)}
            showEditKeywordModal={showEditKeywordModal}
            toggleEditKeywordModal={this.toggleEditKeywordModal}
            user={user}
            isNew={isNew}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.authentication.user,
  projKeywordList: state.keywords.projKeywordLists[ownProps.projectId] || null,
});

export default connect(mapStateToProps)(KeywordsMain);
